"use strict";

export default {
  errorMaxSize: "Die Datei hat die maximal erlaubte Dateigröße von 25 MByte überschritten",
  errorTyp: "Unzulässiges Dateiformat, bitte laden Sie ein Dokument vom Typ .pdf, .png, .jpeg, .jpg hoch.",
  errorServer: "Das Speichern der Datei im Dokumentenmanagement-System ist fehlgeschlagen."
};
